import React, { useContext, useMemo } from 'react';

import { TransactionStatus, ParsedTransaction } from '../../../../../typings/transaction';
import TabsContext from '../contexts/TabsContext';
import useGetUserType from '../../hooks/useGetUserType';
import useGetOrderStatusI18n from '../../hooks/useGetOrderStatusI18n';
import { LEGACY_KYC_STATUS } from '../../../../commons/utils/constants';

import S from './style/AdBlock';

interface StatusProps {
  status: TransactionStatus | '';
  transaction: ParsedTransaction;
}

const Status: React.FC<StatusProps> = ({ transaction, status }) => {
  const tabType = useContext(TabsContext);
  const hideStatus = useMemo(() => LEGACY_KYC_STATUS[status], [status]);
  const { isSeller } = useGetUserType({
    buyerId: transaction?.buyer?.userId,
    sellerId: transaction?.seller?.userId,
  });
  const statusWithLabellessPostingMethod =
    (transaction?.shipment as any)?.postingMethod === 'EXTERNAL_APP' &&
    status === 'SHIPMENT_LABEL_RECEIVED' &&
    isSeller
      ? 'SHIPMENT_CODE_RECEIVED'
      : status;

  const getStatusI18n = useGetOrderStatusI18n();

  const i18nStatus = useMemo(
    () =>
      getStatusI18n({
        tabType,
        orderStatus: statusWithLabellessPostingMethod,
        isInfo: false,
        deliveryType: transaction?.deliveryType || 'P2P',
      }),
    [tabType, status, transaction],
  );

  if (hideStatus) return null;

  return (
    <S.Status data-cy="status" data-testid="status" transaction={transaction}>
      {transaction && i18nStatus}
    </S.Status>
  );
};

export default Status;
